import { CSSProperties } from 'react';
import { IUserDetails } from '@vivli/features/users/infrastructure/interface';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';

/*
 * TODO: When we upgrade ag-grid to or beyond v28, we can re-evaluate if this is necessary
 *  This is only here as a way around not having access to the wrapHeaderText and headerHeight properties for ag-grid yet.
 *  This style sets white-space to normal instead of no-wrap which is the default ag-grid setting.
 */
import './grid-styles.css';
import { OrgMembersGridView } from '@vivli/shared/features/membership/views';
import { useCurrentMembersHook } from '@vivli/features/organizations/infrastructure/hook';

const orgContainerStyle: CSSProperties = {
    width: '100%',
    marginBottom: '10px',
    marginTop: '10px'
};

interface OrgMembershipsGridComponentProps {
    user: IUserDetails;
    setUser: React.Dispatch<React.SetStateAction<IUserDetails>>;
    organizations?: IOrganization[];
}

export const OrgMembershipsGridComponent = ({ user, organizations }: OrgMembershipsGridComponentProps) => {
    const { currentMembers, rolesOrgSpecific } = useCurrentMembersHook('N/A', user.userRole);

    const organizationsWithNames = () => {
        if (!currentMembers) return [];
        return currentMembers
            .reduce((acc, membership) => {
                const displayName = organizations.find((o) => o.id === membership.id)?.name;
                if (displayName) {
                    acc.push({
                        ...membership,
                        displayName
                    });
                }
                return acc;
            }, [])
            .sort((a, b) => a.displayName?.localeCompare(b.displayName));
    };

    if (!currentMembers) return null;
    return (
        <div style={orgContainerStyle}>
            <OrgMembersGridView currentOrgMembers={organizationsWithNames()} rolesOrgSpecific={rolesOrgSpecific} isUserDetails={true} />
        </div>
    );
};
